(function($){
	var $trigger = $('.js-acc-header');
	$trigger.on('click', function(){
		$(this).next('.js-acc-body').slideToggle().toggleClass('isOpen');
		$(this).find('.js-toggle').toggleClass('isExpanded');
	});
})(jQuery);
